// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers"
import Dropdown from 'stimulus-dropdown';
import Notification from 'stimulus-notification';
import Popover from 'stimulus-popover'
import Hotkeys from 'stimulus-hotkeys'
import Clipboard from 'stimulus-clipboard'
import ReadMore from 'stimulus-read-more'
import Lightbox from 'stimulus-lightbox'

application.register('dropdown', Dropdown)
application.register('notification', Notification)
application.register('popover', Popover)
application.register('hotkeys', Hotkeys)
application.register('clipboard', Clipboard)
application.register('read-more', ReadMore)
application.register('lightbox', Lightbox)

const context = require.context(".", true, /\.js$/)

const contextComponents = require.context("../../components", true, /.*(_controller|component)\.js$/)
// const contextComponents2 = require.context("../../components/admin", true, /^.*(_controller|component)\.js$/)

application.load(
  definitionsFromContext(context).concat(
    definitionsFromContext(contextComponents),
    // definitionsFromContext(contextComponents2),
  )
)
